import * as joint from '@joint/plus';

export function initializeTooltips(service) {
  service.tooltip = new joint.ui.Tooltip({
    rootTarget: document.body,
    target: '[data-tooltip]',
    direction: joint.ui.Tooltip.TooltipArrowPosition.Auto,
    padding: 12,
    animation: { delay: '250ms' },
  });
}
